import { PREFERENCES } from "./action";

const initialState = {
  PrefencesList: {}
};

export function preferencesReducer(state = initialState, action) {
  switch (action.type) {
    case PREFERENCES.getPreferences.success:
      return Object.assign({}, state, {
        PrefencesList: action.data || {}
      });
    case PREFERENCES.putPreferences.success:
      return Object.assign({}, state, {
        updatedPreferences: action.data
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/preferences/reducer.js